import Language from './Language.vue';
import Mentions from './Mentions.vue';
export default {
  name: 'MentionsLanguage',
  components: {
    Language: Language,
    Mentions: Mentions
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};